<template>
    <div
        class="detail-appoinment-wrapper"
        @click.stop="appoinmentApp"
    >
        <div
            v-if="appDetail.join_community_info"
            class="appoinment-btn go-community"
            :style="{
                backgroundColor: 'rgba(51,136,255,0.09)',
                width: '25vw',
            }"
            @click.stop="toTieba"
        >
            <div class="btn-text center" :style="{color: '#3388FF'}">
                {{ appDetail.join_community_info.join_community_txt }}
            </div>
        </div>
        <div
            class="appoinment-btn"
            :style="{
                backgroundColor: btnText === '已预约' ? bookedColor : $root.officialHighLightBtnColor,
                width: appDetail.join_community_info ? '63vw' : '91vw',
            }"
        >
            <div class="btn-text center">
                <span>{{ btnText }}</span>
                <span
                    v-if="time"
                    class="text-right"
                >
                    {{ time }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import {generateToken} from '@/utils/tiebaUtility';
import {copy} from '@/utils/browser';
export default {
    props: {
        officialJoined: {
            type: Boolean,
            required: false,
        },
        time: {
            type: String,
            default: '',
        },
        btnText: {
            type: String,
            default: '',
        },
        bookedColor: {
            type: String,
            default: 'rgba(0,0,0,0.2)',
        },
        appDetail: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            pblogData: '',
        };
    },
    mounted() {
        this.$logger.show({
            value: 'reserve',
            ext: {
                item: [
                    {
                        ext: Object.assign(this.$root.extData),
                    },
                ],
            },
        });
    },
    watch: {
        appDetail: {
            handler() {
                if (this.appDetail.join_community_info) {
                    this.$root.sendLog('display', 'communityBtn_display');
                }
            },
        },
    },
    methods: {
        appoinmentApp() {
            this.$emit('appoinmentBtnClick');
            this.$root.sendLog('click', 'reserve', this.$root.extdata);
        },
        toTieba() {
            this.$root.sendLog('click', 'communityBtn_click');
            const token = this.getToken();
            copy(token);
            this.$root.report(token).then(() => {
                TiebaNewWakeUp.init({
                    page: 'frs',
                    param: {
                        kw: this.appDetail.join_community_info?.forum_name || '',
                        fid: this.appDetail.join_community_info?.forum_id || '',
                        obj_source: 'wise',
                        locate: 'outer_game_joinsq',
                    },
                    androidShoubaiGoCenterPage: false,
                    androidDownUrl: this.appDetail.join_community_info.download_url,
                });
            });
        },
        getToken() {
            const config = {
                page: 'frs',
                param: {
                    kw: this.appDetail.join_community_info?.forum_name || '',
                    fid: this.appDetail.join_community_info?.forum_id || '',
                    extdata: {}, // 新schema打点
                    track: '', // fe打点
                    locate: 'gamecenter',
                },
            };
            return generateToken(config);
        },
    },
};

</script>

<style lang="scss" scoped>
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

    *{
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color:transparent;
    }

    .center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .detail-appoinment-wrapper{
        width: px2rem(1242);
        position: fixed;
        bottom: 0;
        height: px2rem(192);
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 -2px 5px #eee;
        .go-community {
            margin-right: 35px;
        }
        .appoinment-btn {
            width: px2rem(1000);
            height: px2rem(132);
            line-height: px2rem(132);
            border-radius: px2rem(66);
            background-color: #38f;
            font-size: px2rem(54);
            color: #fff;
            text-align: center;
            display: flex;
            .btn-text {
                flex: 1;
                .text-right {
                    margin-left: px2rem(30);
                    font-size: px2rem(45);
                }
            }
            .panel-btn {
                flex: 0 0 px2rem(160);
                background-color: #FFF;
                font-size: px2rem(36);
                border: 1px solid;
                border-radius: 0 px2rem(66) px2rem(66) 0;
                display: flex;
                align-items: center;
                flex-direction: column;
                .arrow {
                    transform: translateY(px2rem(45));
                    .icon {
                        width: px2rem(20);
                        height: px2rem(20);
                        transform: rotateZ(45deg);
                        border-top: px2rem(7) solid #38f;
                        border-left: px2rem(7) solid #38f;
                    }
                }
                .text {
                    transform: translateY(px2rem(17));
                }
            }
        }
    }
</style>